import { DataLoadingWrapper } from "@jugl-web/ui-components";
import { useTranslations } from "@jugl-web/utils";
import { FC } from "react";
import { useAgentAnalyticsContext } from "@jugl-web/domain-resources/analytics";
import { SentimentAnalysisWidget } from "../SentimentAnalysisWidget";
import { TopicDistributionWidget } from "../TopicDistributionWidget";
import { AnalyticsPageHeader } from "../AnalyticsPageHeader";

export const ChatsSentimentTabContent: FC = () => {
  const {
    sentimentAnalysisData,
    topicDistributionData,
    isLoading,
    isError,
    refetch,
  } = useAgentAnalyticsContext();

  const { t } = useTranslations();

  return (
    <DataLoadingWrapper
      isLoading={isLoading}
      isError={isError}
      onRetry={() => refetch()}
    >
      <div className="mx-auto flex w-full flex-col gap-10 p-12">
        <AnalyticsPageHeader
          title={t({
            id: "cx-analytics.chats-sentiment-tab-title",
            defaultMessage: "Chats Sentiment",
          })}
          subtitle={t({
            id: "cx-analytics.chats-sentiment-tab-subtitle",
            defaultMessage:
              "Understand users satisfaction based on the tone and sentiment of conversations",
          })}
          hints={[
            t({
              id: "cx-analytics.chats-sentiment-hint-1",
              defaultMessage:
                "See how customers feel across your conversations 👀",
            }),
            t({
              id: "cx-analytics.chats-sentiment-hint-2",
              defaultMessage:
                "Track sentiment by topic, channel, and outcome (AI vs humans) 🤝",
            }),
            t({
              id: "cx-analytics.chats-sentiment-hint-3",
              defaultMessage:
                "Use these insights to identify issues and improve customer experience ✨",
            }),
          ]}
        />
        <div className="flex flex-col gap-14">
          <SentimentAnalysisWidget data={sentimentAnalysisData} />
          <TopicDistributionWidget data={topicDistributionData} />
        </div>
      </div>
    </DataLoadingWrapper>
  );
};
